import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class SitingService {
  constructor(private http: HttpClientService) {}

  public getAllSitingStates(): Observable<any> {
    return this.http.get("/api/siting_state").pipe(tap((_) => console.log("SitingService.getSitingStates: Ok.")));
  }

  public getSitingStates(params?): Observable<any> {
    return this.http
      .get("/api/siting_state/active", { params })
      .pipe(tap((_) => console.log("SitingService.getSitingStates: Ok.")));
  }
  public getSitingState(siting_id): Observable<any> {
    return this.http
      .get(`/api/siting_state/${siting_id}`)
      .pipe(tap((_) => console.log("SitingService.getSitingState: Ok.")));
  }

  public postSitingState(siting_state): Observable<any> {
    return this.http
      .post("/api/siting_state", siting_state)
      .pipe(tap((_) => console.log("SitingService.postSitingStates: Ok.")));
  }

  public putSitingState(id, siting_state): Observable<any> {
    return this.http
      .put("/api/siting_state/" + id, siting_state)
      .pipe(tap((_) => console.log("SitingService.putSitingStates: Ok.")));
  }
}
